import { ensureAuthenticated } from 'utils/auth';
import Logger from 'utils/logger';

let baseUrl = '/api'
const environment = process.env.NODE_ENV;

function authenticate() {
  return ensureAuthenticated();
}

async function callApi(method, endpoint, body = null, headers = {}) {
  const auth = await authenticate();
  const session = auth.getSignInUserSession();
  const jwtToken = session.getIdToken().getJwtToken();

  if (environment === 'production') {
    baseUrl = process.env.BUSINESS_LOGIC_API;
  }

  const url = `${baseUrl}${endpoint}`;

  async function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    if (response.status === 427) {
      const responseBody = await response.json();
      const error = new Error(responseBody.message);
      error.response = response;
      throw error;
    } else if (response.status >= 300 && response.status < 500) {
      const error = new Error(response.statusText)
      error.response = response;
      throw error;
    } else {
      const error = new Error(CONSTANT.GENERIC_ERROR_MESSAGE);
      error.response = response;
      throw error;
    }
  }

  function parseJSON(response) {
    return response.json();
  }
  const response = await fetch(url, {

    method,
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      ...headers,
      Authorization: jwtToken,

    },
    redirect: 'follow',
    referrer: 'no-referrer',
    body: method === 'GET' ? null : JSON.stringify(body),
  });
  await checkStatus(response);
  const result = await parseJSON(response);

  Logger.logInfo(`HTTP ${method} ${endpoint} = ${result}`);
  return result;
}


const API = {
  async getICData(payload) {

    Logger.logInfo(payload);
    const result = await callApi('POST', '/getICData', payload);

    return result;
  },

  async downloadSourceData(path) {
    const result = await callApi(
      'GET',
      path,
    );
    Logger.logInfo(`downloadTemplate() = ${result}`);
    return result;
  },

  async getColumnMetadata() {
    const result = await callApi('GET', '/getColumnMetadata');
    return result;
  },

  async getCalcDetailData() {
    const result = await callApi('GET', '/getICJob');
    return result
  },

  async saveCalcDetailData(id, calcDetail) {
    Logger.logInfo(calcDetail);
    return await callApi('POST', '/saveCalcDetail' ,{id: id, calculationDetails: calcDetail});
  },

  async saveJobData(jobData) {
    Logger.logInfo(jobData);
    return await callApi('POST', '/saveICJob', {jobData: jobData});
  }

};

export default API;